
riot.tag2('measure-edit', '  <loader if="{loader}">\n    <virtual hide="{loader}">\n      <div class="btn-group"><a class="btn btn-default" href="#measurements"><i class="fa fa-chevron-left"></i></a>\n        <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;paysystems&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n        <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n      </div>\n      <div class="h4">{isNew ? item.namePayment || \'Добавление платежной системы\' : item.namePayment || \'Редактирование платежной системы\'}</div>\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="form-group {has-error: error.namePayment}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="namePayment" type="text" value="{item.namePayment}">\n          <div class="help-block">{error.namePayment}</div>\n        </div>\n      </form>\n    </virtual>\n  </loader>\n', '', '', function(opts) {
'use strict';

var self = this;

observable.on('measure-edit', function (id, section) {
    console.log("ok");

    self.error = false;
    self.loader = true;
    self.isNew = false;
    self.item = {};
    self.update();

    API.request({
        object: 'PaySystem',
        method: 'Info',
        data: { id: id },
        success: function success(response) {
            self.item = response;
            observable.trigger('pay-systems-reload');
        },
        error: function error(response) {
            self.item = {};
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/settings/measurements/measure-edit.tag